// Componente eliminado - ya no se utiliza
export default function ReservationWidget() {
  return null;
};